import { render, staticRenderFns } from "./LaravelFileDownload.vue?vue&type=template&id=5bae4f99&scoped=true"
import script from "./LaravelFileDownload.vue?vue&type=script&lang=js"
export * from "./LaravelFileDownload.vue?vue&type=script&lang=js"
import style0 from "./LaravelFileDownload.vue?vue&type=style&index=0&id=5bae4f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae4f99",
  null
  
)

export default component.exports